import script from "./PostListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostListItem.vue?vue&type=script&setup=true&lang=ts"

import "./PostListItem.vue?vue&type=style&index=0&id=66f4e1a2&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f4e1a2"]])

export default __exports__